/** Etiquetas compartidas del tablero mensual de honorarios. */

/** Alineado con tarjetas de Control de cobranza. */
export const BILLING_CONDITION_LABELS = {
  factura: "Clientes con factura CFDI",
  otros_pagos: "Clientes otros conceptos",
  no_recurrente: "Clientes eventuales",
  convenio: "Convenios (grupos)",
  cortesia: "Clientes con cortesía",
  eventual_act_empresarial: "Eventuales act. empresarial",
  eventual: "Clientes eventuales",
};

export const OPERATIONAL_STATUS_LABELS = {
  pending: "Pendiente",
  paid_manual: "Pagado",
  not_applicable: "No aplica",
};

export const FISCAL_STATUS_LABELS = {
  no_cfdi: "Sin CFDI",
  paid_sat: "Pagado SAT",
  pending_complement: "PPD sin compl.",
  pending_review: "Revisión",
  pending_payment: "Pendiente pago",
  partial_payment: "Pago parcial",
  cancelled: "Cancelada",
  not_applicable: "No aplica",
  not_related: "No relacionada",
};

export const REMINDER_STATUS_LABELS = {
  pending: "Pendiente",
  sent: "Enviado",
  skip: "No enviar",
};

/** Estado del correo de cobranza (independiente del recordatorio WhatsApp). */
export const COLLECTION_EMAIL_STATUS_LABELS = {
  pending: "Sin enviar",
  sent: "Correo enviado",
  failed: "Error al enviar",
  no_email: "Sin correo en ficha",
};
